<div class="page-shell">
<mat-toolbar class="header">
  <span>{{ "digitalCards.sources.title" | translate }}: {{ allSources.length }}</span>
  <div class="actions">
    <button
      mat-stroked-button
      type="button"
      (click)="loadSources()"
      [disabled]="tableLoading"
    >
      <mat-icon>refresh</mat-icon>
      {{ "cardOrders.refresh" | translate }}
    </button>
    <button mat-raised-button color="primary" type="button" (click)="openCreate()">
      <mat-icon>add</mat-icon>
      {{ "digitalCards.sources.add" | translate }}
    </button>
  </div>
</mat-toolbar>

<div class="stats-wrapper">
  <form class="filters-row">
    <mat-form-field class="search-field" appearance="outline" subscriptSizing="dynamic">
      <input
        matInput
        [formControl]="searchControl"
        [placeholder]="'digitalCards.sources.searchPlaceholder' | translate"
        [attr.aria-label]="'auditLog.search' | translate"
      />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </form>

  <div
    class="table-container"
    [class.table-container--empty]="isEmpty || showNoSearchResults || loadFailed"
    [class.table-container--loading]="tableLoading"
  >
    <mat-table
      [dataSource]="filteredSources"
      matSort
      [matSortActive]="sortBy"
      [matSortDirection]="sortDirection"
      (matSortChange)="onSortChange($event)"
      class="sources-table mat-elevation-z0"
    >
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "digitalCards.sources.colName" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="hits">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "digitalCards.sources.colHits" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="cell-num">
          {{ row.totalHits | number }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "digitalCards.sources.colCreated" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ formatCreatedAt(row.createdAt) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>
          {{ "digitalCards.sources.colActions" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="actions-cell">
          <div class="table-actions">
            <button type="button" class="action-btn" (click)="openShare(row, $event)">
              <mat-icon>share</mat-icon>
              {{ "digitalCards.share" | translate }}
            </button>
            <button
              type="button"
              class="action-btn action-btn--danger"
              [disabled]="deletingId === row.id"
              (click)="deleteSource(row, $event)"
            >
              @if (deletingId === row.id) {
                <mat-spinner diameter="16" class="dbc1-spinner dbc1-spinner--sm"></mat-spinner>
              } @else {
                <mat-icon>delete_outline</mat-icon>
              }
              {{
                (deletingId === row.id
                  ? "digitalCards.deleting"
                  : "digitalCards.sources.delete"
                ) | translate
              }}
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div class="loading-wrapper" *ngIf="tableLoading">
      <app-loading></app-loading>
    </div>

    <div class="empty-state" *ngIf="!tableLoading && loadFailed">
      <mat-icon class="empty-state__icon">error_outline</mat-icon>
      <p>{{ "digitalCards.sources.loadFailed" | translate }}</p>
      <button mat-stroked-button type="button" (click)="loadSources()">
        <mat-icon>refresh</mat-icon>
        {{ "cardOrders.refresh" | translate }}
      </button>
    </div>

    <div class="empty-state" *ngIf="!tableLoading && isEmpty">
      <mat-icon class="empty-state__icon">campaign</mat-icon>
      <p>{{ "digitalCards.sources.empty" | translate }}</p>
      <button mat-raised-button color="primary" type="button" (click)="openCreate()">
        <mat-icon>add</mat-icon>
        {{ "digitalCards.sources.add" | translate }}
      </button>
    </div>

    <div class="empty-state" *ngIf="showNoSearchResults">
      <mat-icon class="empty-state__icon">search_off</mat-icon>
      <p>{{ "auditLog.noData" | translate }}</p>
    </div>
  </div>
</div>
</div>
